const appGlobal = typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};

appGlobal.version = "1.0.2";

appGlobal.menu = [
    { title: "Overview" },
    { name: "Welcome", icon: "\uf015", link: "/welcome", moduleKey: "welcome" },
    // { name: "Dashboard", icon: "\uf0e4", link: "/dashboard", moduleKey: "dashboard" },
    { name: "โปรไฟล์ของฉัน", icon: "\uf2bd", link: "/my-profile", moduleKey: "welcome" },

    { title: "Work" },
    { name: "ทะเบียนโปรเจค", icon: "\uf542", link: "/projects", moduleKey: "projects" },
    { name: "ไทม์ไลน์โปรเจค", icon: "\uf0ae", link: "/project-timeline", moduleKey: "project_timelines" },
    { name: "สัญญา MA", icon: "\uf0ad", link: "/ma-contracts", moduleKey: "ma_contracts" },
    // superOnly: เห็นและใช้ได้เฉพาะบัญชี user_type = super_user เท่านั้น (ไม่ผูก permission ของ role, backend ล็อกด้วย checkSuperUser)
    { name: "สัญญาพัฒนาระบบ", icon: "\uf56c", link: "/dev-contracts", moduleKey: "dev_contracts", superOnly: true },
    { title: "Workforce" },
    { name: "พนักงาน", icon: "\uf0c0", link: "/employees", moduleKey: "employees" },
    { name: "เวลาเข้าออกงาน", icon: "\uf017", link: "/attendance", moduleKey: "attendance" },
    { name: "การลา", icon: "\uf073", link: "/leave", moduleKey: "leaves" },

    { title: "Finance" },
    { name: "เงินเดือน", icon: "\uf0d6", link: "/payroll", moduleKey: "payroll" },
    // { name: "สลิปเงินเดือน", icon: "\uf15c", link: "/payslips", moduleKey: "payslips" },
    // { name: "ค่าล่วงเวลา", icon: "\uf254", link: "/overtime", moduleKey: "overtime" },
    // { name: "ภาษีบริษัท", icon: "\uf1ec", link: "/tax", moduleKey: "tax" },
    // { name: "ประกันสังคม", icon: "\uf3ed", link: "/social-security", moduleKey: "social-security" },
    { name: "ธุรกรรมการเงินบริษัท", icon: "\uf362", link: "/finance-transactions", moduleKey: "finance_transactions" },
    { name: "ธุรกรรมการเงินพนักงาน", icon: "\uf4c0", link: "/employee-finance", moduleKey: "finance_transactions" },
    { name: "สรุปยอดเงินบริษัท", icon: "\uf200", link: "/finance-summary", moduleKey: "finance_transactions" },
    { name: "เอกสารการเงิน", icon: "\uf07c", link: "/company-documents", moduleKey: "company_documents" },

    { title: "Operations" },
    // { name: "ทรัพย์สินบริษัท", icon: "\uf1ad", link: "/assets", moduleKey: "assets" },
    // { name: "จัดซื้อ", icon: "\uf07a", link: "/procurement", moduleKey: "procurement" },
    { name: "ไฟล์ข้อมูลบริษัท", icon: "\uf0a0", link: "/company-drive", moduleKey: "drive" },
    { name: "ลูกค้า / คู่ค้า", icon: "\uf2bb", link: "/partners", moduleKey: "partners" },
    // { name: "ประกาศภายใน", icon: "\uf0a1", link: "/announcements", moduleKey: "announcements" },

    { title: "System" },
    { name: "ตั้งค่าระบบ", icon: "\uf013", link: "/settings", moduleKey: "setting" },
    { name: "ประวัติการใช้งานระบบ", icon: "\uf1da", link: "/audit-logs", moduleKey: "audit_logs" },
];

// เมนูของระบบ CMRU (ระบบแยก มี navbar ของตัวเอง) ทุกลิงก์ขึ้นต้นด้วย /cmru/
// ไม่ผูกกับ role/permission: ใครเข้าระบบ CMRU ได้ (ดู profile.systems.cmru) จะเห็นทุกเมนูในนี้
appGlobal.cmruMenu = [
    { title: "Overview" },
    { name: "Welcome", icon: "\uf015", link: "/cmru/welcome" },

    { title: "Registration" },
    { name: "รายชื่อนักศึกษาลงทะเบียน", icon: "\uf46d", link: "/cmru/class-lists" },
];

// เมนูของระบบ "กินอะไรดี" (AI Food Personal Assistant) ระบบแยก มี navbar ของตัวเอง ทุกลิงก์ขึ้นต้นด้วย /food/
// ไม่ผูกกับ role/permission เช่นเดียวกับ CMRU: ใครเข้าระบบนี้ได้ (ดู profile.systems.food) จะเห็นทุกเมนูในนี้
appGlobal.foodMenu = [
    { title: "Today" },
    { name: "หน้าแรก · วันนี้กินอะไรดี", icon: "\uf015", link: "/food/home" },
    { name: "ให้ AI เลือกให้", icon: "\uf544", link: "/food/decide" },

    { title: "Track" },
    { name: "บันทึกอาหารที่กิน", icon: "\uf46d", link: "/food/diary" },
    { name: "งบอาหาร", icon: "\uf555", link: "/food/budget" },

    { title: "Discover" },
    { name: "ทำจากของที่มีอยู่ (ตัวอย่าง)", icon: "\uf2e7", link: "/food/pantry" },
    { name: "ร้านอาหารใกล้ฉัน (ตัวอย่าง)", icon: "\uf3c5", link: "/food/nearby" },
    { name: "ฐานข้อมูลเมนู", icon: "\uf02d", link: "/food/foods" },

    { title: "Me" },
    { name: "โปรไฟล์การกิน", icon: "\uf2bd", link: "/food/profile" },
];

// ระบบทั้งหมดที่สลับได้จากตัวสลับระบบใต้โลโก้ใน navbar
// theme = สีหลักของ navbar ในระบบนั้น ให้รู้ทันทีว่ากำลังอยู่ระบบไหน (กันบันทึกข้อมูลผิดระบบ)
appGlobal.systems = {
    main: {
        key: "main",
        name: "ParthenonTech",
        caption: "ระบบบริหารองค์กร",
        icon: "\uf1ad",
        home: "/welcome",
        menu: appGlobal.menu,
        usesPermission: true,
        theme: {
            gradient: "linear-gradient(135deg, #0f6bdc 0%, #1f8ce5 48%, #27d6dd 100%)",
            solid: "#0f6bdc",
            soft: "linear-gradient(135deg, rgba(15, 107, 220, 0.10) 0%, rgba(39, 214, 221, 0.18) 100%)",
            shadow: "rgba(15, 107, 220, 0.24)",
        },
    },
    cmru: {
        key: "cmru",
        name: "CMRU",
        caption: "ระบบของ CMRU",
        // ชื่อหน่วยงานที่แสดงคู่กับโลโก้บนสุดของ navbar
        brand: { th: "มหาวิทยาลัยราชภัฏเชียงใหม่", en: "Chiang Mai Rajabhat University" },
        icon: "\uf19d",
        home: "/cmru/welcome",
        menu: appGlobal.cmruMenu,
        usesPermission: false,
        theme: {
            // เขียว-ทอง ตามสีตรามหาวิทยาลัย
            gradient: "linear-gradient(135deg, #00563a 0%, #00734c 55%, #2f9e6e 100%)",
            solid: "#00734c",
            soft: "linear-gradient(135deg, rgba(0, 115, 76, 0.10) 0%, rgba(201, 162, 39, 0.20) 100%)",
            shadow: "rgba(0, 115, 76, 0.26)",
        },
    },
    food: {
        key: "food",
        name: "กินอะไรดี",
        caption: "AI Food Personal Assistant",
        brand: { th: "วันนี้กินอะไรดี", en: "AI Food Personal Assistant" },
        icon: "\uf2e7",
        home: "/food/home",
        menu: appGlobal.foodMenu,
        usesPermission: false,
        theme: {
            // ส้ม-อำพัน โทนอาหาร/ความอยากอาหาร
            gradient: "linear-gradient(135deg, #d9481c 0%, #f06d2a 55%, #ffb347 100%)",
            solid: "#e8641f",
            soft: "linear-gradient(135deg, rgba(232, 100, 31, 0.12) 0%, rgba(255, 179, 71, 0.22) 100%)",
            shadow: "rgba(232, 100, 31, 0.26)",
        },
    },
};

// ระบบแยกที่บัญชีนี้เข้าได้: ระบบหลักเสมอ + ระบบที่ backend ติดธงไว้ใน profile.systems[key] (allowlist อีเมลใน config ของ backend)
appGlobal.getAvailableSystems = (profile) => Object.values(appGlobal.systems).filter((system) => system.key === "main" || !!profile?.systems?.[system.key]);
appGlobal.hasSystemAccess = (profile, key) => !!appGlobal.getAvailableSystems(profile).find((system) => system.key === key);

appGlobal.bank = [
    { icon: "KBANK.png", value: "KBANK", label: "Kasikorn Bank", name_th: "ธนาคารกสิกรไทย", code: "004" },
    { icon: "SCB.png", value: "SCB", label: "Siam Commercial Bank", name_th: "ธนาคารไทยพาณิชย์", code: "014" },
    { icon: "KTB.png", value: "KTB", label: "Krung Thai Bank", name_th: "ธนาคารกรุงไทย", code: "006" },
    { icon: "BAY.png", value: "BAY", label: "Bank of Ayudhya", name_th: "ธนาคารกรุงศรีอยุธยา", code: "025" },
    { icon: "BBL.png", value: "BBL", label: "Bangkok Bank", name_th: "ธนาคารกรุงเทพ", code: "002" },
    { icon: "GSB.png", value: "GSB", label: "Government Savings Bank", name_th: "ธนาคารออมสิน", code: "030" },
    { icon: "CIMB.png", value: "CIMB", label: "CIMB Thai", name_th: "ธนาคารซีไอเอ็มบีไทย", code: "022" },
    { icon: "LHB.png", value: "LHB", label: "Land and Houses Bank", name_th: "ธนาคารแลนด์แอนด์เฮ้าส์", code: "073" },
    { icon: "UOB.png", value: "UOB", label: "United Overseas Bank", name_th: "ธนาคารยูโอบี (ไทย)", code: "024" },
    { icon: "BAAC.png", value: "BAAC", label: "Bank for Agriculture and Agricultural Cooperatives", name_th: "ธ.ก.ส.", code: "034" },
    { icon: "GHB.png", value: "GHB", label: "Government Housing Bank", name_th: "ธนาคารอาคารสงเคราะห์", code: "033" },
    { icon: "TTB.png", value: "TTB", label: "TTB Thanachart Bank", name_th: "ธนาคารทหารไทยธนชาต", code: "011" },
];

const appModules = {
    dashboard: {
        title: "Dashboard",
        description: "ภาพรวมการดำเนินงานของบริษัทในมุมมองผู้บริหารและทีมปฏิบัติการ",
        highlights: ["Company overview", "Pending actions", "Monthly status"],
    },
    employees: {
        title: "พนักงาน",
        description: "จัดการข้อมูลพนักงาน โครงสร้างทีม และสถานะการทำงานในองค์กร",
        highlights: ["Employee directory", "Org chart", "Employment status"],
    },
    attendance: {
        title: "เวลาเข้าออกงาน",
        description: "ติดตามเวลาเข้างาน การขาดลา มาสาย และสรุปเวลาในแต่ละรอบงาน",
        highlights: ["Daily attendance", "Late arrivals", "Shift summary"],
    },
    leave: {
        title: "การลา",
        description: "อนุมัติคำขอลา ตรวจสอบสิทธิ์คงเหลือ และประวัติการลา",
        highlights: ["Leave requests", "Leave balance", "Approval queue"],
    },
    payroll: {
        title: "เงินเดือน",
        description: "จัดการรอบเงินเดือน รายการหัก รายการเพิ่ม และสถานะการจ่าย",
        highlights: ["Payroll cycle", "Earnings & deductions", "Payment status"],
    },
    payroll_create: {
        title: "ออกเงินเดือน",
        description: "สร้างรอบเงินเดือนใหม่ กำหนดช่วงวันที่ และปรับรายการเงินได้/รายการหักของพนักงานแต่ละคน",
        highlights: ["Payroll period", "Bulk employee entry", "Earnings & deductions"],
    },
    payslips: {
        title: "สลิปเงินเดือน",
        description: "ดูและจัดเก็บสลิปเงินเดือนของพนักงานย้อนหลังอย่างเป็นระบบ",
        highlights: ["Monthly slips", "Archive", "Secure access"],
    },
    overtime: {
        title: "ค่าล่วงเวลา",
        description: "ตรวจสอบชั่วโมง OT สรุปรายการอนุมัติ และเชื่อมเข้ารอบเงินเดือน",
        highlights: ["OT requests", "Approved hours", "Payroll sync"],
    },
    tax: {
        title: "ภาษีบริษัท",
        description: "ติดตามภาษีหัก ณ ที่จ่าย ภาษีเงินได้ และภาระภาษีของบริษัท",
        highlights: ["Corporate tax", "Withholding tax", "Tax calendar"],
    },
    "social-security": {
        title: "ประกันสังคม",
        description: "ดูยอดส่งประกันสังคมของบริษัทและพนักงานในแต่ละงวด",
        highlights: ["Contribution summary", "Monthly filing", "Employee coverage"],
    },
    assets: {
        title: "ทรัพย์สินบริษัท",
        description: "ติดตามครุภัณฑ์ อุปกรณ์ และสถานะการถือครองของพนักงาน",
        highlights: ["Asset registry", "Assignments", "Maintenance status"],
    },
    procurement: {
        title: "จัดซื้อ",
        description: "ดูคำขอจัดซื้อ สถานะอนุมัติ และค่าใช้จ่ายที่เกี่ยวข้องกับบริษัท",
        highlights: ["Purchase requests", "Budget review", "Vendor tracking"],
    },
    documents: {
        title: "เอกสารบริษัท",
        description: "รวมเอกสารสำคัญ นโยบายบริษัท และไฟล์ภายในที่ใช้ร่วมกัน",
        highlights: ["Policies", "Company files", "Internal access"],
    },
    announcements: {
        title: "ประกาศภายใน",
        description: "กระดานข่าวสำหรับอัปเดตประกาศและการสื่อสารภายในองค์กร",
        highlights: ["Internal updates", "HR notices", "Company news"],
    },
    cmru_welcome: {
        title: "CMRU",
        description: "มหาวิทยาลัยราชภัฏเชียงใหม่ · หน้าแรก",
        highlights: [],
    },
    cmru_class_lists: {
        title: "รายชื่อนักศึกษาลงทะเบียน",
        description: "มหาวิทยาลัยราชภัฏเชียงใหม่ · นำเข้าและจัดการรายชื่อนักศึกษาในแต่ละกลุ่มเรียน",
        highlights: [],
    },
    food_home: { title: "วันนี้กินอะไรดี", description: "AI Food Personal Assistant · สรุปพลังงานวันนี้และคำแนะนำมื้อถัดไป", highlights: [] },
    food_decide: { title: "ให้ AI เลือกให้", description: "ตอบ 3 คำถามสั้น ๆ แล้วให้ AI ตัดสินใจมื้อนี้พร้อมเหตุผล", highlights: [] },
    food_diary: { title: "บันทึกอาหารที่กิน", description: "จดมื้ออาหารแต่ละวัน ดูสารอาหารที่ได้ และสิ่งที่ AI เรียนรู้จากพฤติกรรมการกิน", highlights: [] },
    food_budget: { title: "งบอาหาร", description: "วางแผนงบต่อวัน ต่อมื้อ และติดตามค่าใช้จ่ายอาหารรายเดือน", highlights: [] },
    food_pantry: { title: "ทำจากของที่มีอยู่", description: "เลือกวัตถุดิบในตู้เย็น แล้วให้ AI แนะนำเมนูที่ทำได้พร้อมวิธีทำ", highlights: [] },
    food_nearby: { title: "ร้านอาหารใกล้ฉัน", description: "ค้นหาเมนูใกล้ตัวที่ตรงกับเป้าหมายและงบของคุณ", highlights: [] },
    food_foods: { title: "ฐานข้อมูลเมนู", description: "รายการเมนูอาหารพร้อมพลังงาน สารอาหาร ราคา และแท็กสำหรับการแนะนำ", highlights: [] },
    food_profile: { title: "โปรไฟล์การกิน", description: "ข้อมูลส่วนตัว เป้าหมาย ความชอบ และข้อจำกัด ที่ AI ใช้ปรับคำแนะนำให้เป็นของคุณ", highlights: [] },
    settings: {
        title: "ตั้งค่าระบบ",
        description: "ตั้งค่าทั่วไป สิทธิ์การเข้าถึง และข้อมูลพื้นฐานของระบบบริษัท",
        highlights: ["Access control", "Company config", "Admin settings"],
    },
};

export const appVersion = appGlobal.version;
export const appMenu = appGlobal.menu;
export const appSystems = appGlobal.systems;
export const appBank = appGlobal.bank;
export const getAvailableSystems = appGlobal.getAvailableSystems;
export const hasSystemAccess = appGlobal.hasSystemAccess;
export { appModules };
